<script setup>
  import { storeToRefs } from "pinia";
  import ListContainer from "@/components/episto-ui/list/ListContainer.vue";
  import ListItem from "@/components/episto-ui/list/ListItem.vue";
  import { useContactsStore } from "@stores/survey/mailing/contacts";

  const contactsStore = useContactsStore();
  const { contacts } = storeToRefs(contactsStore);
  const { addContact, selectContact, duplicateContact, removeContact, isContactSelected } = contactsStore;
</script>

<template>
  <ListContainer
    :add-element="addContact"
    :show-header="false"
    element-name="contact">
    <template #elements>
      <ListItem
        v-for="(contact, index) in contacts"
        :key="contact.id"
        :index="index"
        :element-title="contact.name"
        :select-element="selectContact"
        :delete-element="removeContact"
        :duplicate-element="duplicateContact"
        :is-element-selected="isContactSelected" />
    </template>
  </ListContainer>
</template>
